/**
 * Sync country dropdown with Marketo
 * @module sync-country-field
 * @author Vincent Falconi <vfalconi@sumologic.com>
 */



/**
 * Remove existing options from Country dropdown
 * @param {element} select
 */
const removeOptions = (select) => {
	const options = select.querySelectorAll('option');

	Array.from(options).forEach(el => {
		el.remove();
	});
}



/**
 * Add options from Marketo to Country dropdown
 * @param {element} select
 * @param {array} options
 */
const addOptions = (select, options) => {
	const defaultOpt = document.createElement('option');
	const clones = Array.from(options).map((node) => node.cloneNode(true));

	defaultOpt.selected = true;

	select.append(defaultOpt);
	select.append(...clones);
}



/**
 * Replace the options in the country dropdown with whatever is in
 * the Marketo field. This prevents validation errors due to list
 * changes.
 */
export default () => {
	const countrySelect = document.querySelector('#slf-activate #country');
	const marketoOptions = document.querySelectorAll('#mktoForm_5688 #Country option:not(:first-child)');

	if (countrySelect) {
		removeOptions(countrySelect);
		addOptions(countrySelect, marketoOptions);
	}
}
